// extracted by mini-css-extract-plugin
export default {"container":"Job_container__3z-5W","titleCompany":"Job_titleCompany__noFy2","link":"Job_link__F3kSz","period":"Job_period__zNMu4","description":"Job_description__00tGU"};